import React from "react";
import QuestionPreviewState, {
  QuestionPreviewProps,
} from "./QuestionPreview.models";
import "./QuestionPreview.scss";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";

export default class QuestionPreview extends React.PureComponent<
  QuestionPreviewProps,
  QuestionPreviewState
> {
  transformWrapperRef: React.RefObject<any>;
  constructor(props:any){
    super(props);
    this.state= {}
    this.transformWrapperRef = React.createRef();
  }
  
  close() {
    let { onClose } = this.props;

    this.transformWrapperRef.current?.resetTransform()
    onClose()
  }

  render(): React.ReactNode {
    let { showModal, attachmentId } = this.props;
    let image = `https://cdn.barandehsaz.com/FileUploader/Download/?AttachmentID=${attachmentId}`;
    return (
      <>
        <div className={showModal ? "display-block" : "display-none"}>
          <div className="cover"></div>
          <div className="image-area">
            <div className="col-12 area-close-button">
              <button
                className="btn btn-link mdi mdi-close mdi-24px"
                onClick={this.close.bind(this)}
              ></button>
            </div>
            <div className="col-12">
              <TransformWrapper
                centerOnInit
                centerZoomedOut
                ref={this.transformWrapperRef}
              >
                {({resetTransform, ...rest }) => (
                  <TransformComponent>
                    <img src={image} alt="question" className="full-width"  />
                  </TransformComponent>
                )}
              </TransformWrapper>
            </div>
          </div>
        </div>
      </>
    );
  }
}
